import React ,{useEffect} from "react";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import { DashboardHeaderSchema } from "./schema/DashboardHeaderSchema"
 import {toIndianCurrencywithoutSymbol} from "../../helperFunctions/helperFunctions"
const DashboardHeader = ({
  response,
  userName
}) => {

  console.log(response)
  const tableValue = response[0];

  useEffect(() => {
    DashboardHeaderSchema.forEach((element) => {
      console.log(element);
      element.value = '';
      if(element.statsHeading == "Total Subscription"){
        element.value = tableValue.total_applns
      } else  if(element.statsHeading == "Total Allotments"){
        element.value = tableValue.total_bids
      }else  if(element.statsHeading == "Total Rejections"){
        element.value = tableValue.not_alloted
      }else  if(element.statsHeading == "Total Modified"){
        element.value = tableValue.bids_modified
      }else  if(element.statsHeading == "Total Cancellations"){
        element.value = tableValue.bids_cancelled
      }
    });

    console.log(DashboardHeaderSchema)
  }, []);

  
  const CurrentValPercentage = 90;
  const totalSubscriptionPercentage = 60;

  const calculatePercentage = (currentValue, field, data) =>{
    

    
    return currentValue;
    // check and proceed 
    // let totalapplicant = data.total_applns;
    // if(totalapplicant == 0){
    //   return 0;
    // }
    // if(field == "Total Subscription"){
    //   return 100; // (currentValue/currentValue)*100
    // } else  if(field == "Total Allotments"){
    //   let allotment = (currentValue/totalapplicant)*100;
    //   return allotment;
    // }else  if(field == "Total Rejections"){
    //   let allotment = (currentValue/totalapplicant)*100;
    //   console.log("-------------")
    //   console.log(allotment)
    //   return allotment;
    // }else  if(field == "Total Modified"){
    //   let allotment = (currentValue/totalapplicant)*100;
    //   return allotment;
    // }else  if(field == "Total Cancellations"){
    //   let allotment = (currentValue/totalapplicant)*100;
    //   return allotment;
    // }
  }
  return (
    <div>
      <div className="topbanner shadow">
        <div className="row">
          <div className="col-md-8 col-sm-12">
            <p className="mb-0 txt-whiteColorname">Hello {userName}!</p>
          </div>
          {/* <div className="col-md-2 col-xsm-3  pt-4 BannerDropDown">
            <select
              className="form-select form-select-sm mb-3 bannerSelectOptions"
              aria-label=".form-select-sm example"
            >
              <option>FY 2019-20</option>
            </select>
          </div> */}
        </div>
      </div>
      {/* <div className="card values">
        <div className="row m-0 p-md-3 p-0 hideMobile">
          <div className="col-lg-3 col-md-4 d-md-flex place-content-space-between align-items-center">
         
            <div className="valuetxt align-items-center">
              <p className="mb-1 headerGraphLabel">
               
                current value (₹)
              </p>
              <p className="txt-blue b mb-0">
               
              {toIndianCurrencywithoutSymbol(Number(tableValue.current_value))}
              </p>
            </div>
          </div>
          <hr className="hide-sm m-0 "></hr>
          <div className="col-lg-3 col-md-4  my-2 d-md-flex place-content-space-between">
            <div className="valuetxt align-items-center">
              <p className="mb-1 headerGraphLabel">
         
                Dividends Received (₹)
              </p>
              <p className="text-success b mb-0">
               
                {toIndianCurrencywithoutSymbol(Number(tableValue.dividends_recd))}
              </p>
            </div>
          </div>
        
          <div className="col-lg-3 col-md-4 hide-md my-2 d-md-flex place-content-space-between">
            <div className="valuetxt align-items-center">
              <p className="mb-1 headerGraphLabel">
               
                Dividends Unpaid (₹)
              </p>
              <p className="text-danger b mb-0">
              
                --
              </p>
            </div>
          </div>
        </div>
        <div className="row m-0 p-md-3 p-0 showMobile">

          <div className="indetailsmobvalue">
            <p className="mobGraphValu">Current Value (₹)</p>
            <p className="mobileficolor">{toIndianCurrencywithoutSymbol(Number(tableValue.current_value))}</p>
          </div>

          <div className="indetailsmobvalue">
            <p className="mobGraphValu">Dividends received (₹)</p>
            <p className="mobileficolorSecond">{toIndianCurrencywithoutSymbol(Number(tableValue.dividends_recd))}</p>
          </div>

          <div className="indetailsmobvalue">
            <p className="mobGraphValu">Dividends Unpaid (₹)</p>
           
            <p className="mobileficolorThird">--</p>
          </div>
        </div>

      </div> */}
      <div className="hide-md my-4">

        {/* <div className="stats">
          {DashboardHeaderSchema.map((stats, i) => {
            return (
                <div className="dashbox dashboxRight" key={i}>
                  <div className="card p-2 mb-3 border-0">
                    <div className="d-flex align-items-center">
                      <div className="">
                        <CircularProgressbar
                          value={calculatePercentage(stats.totalSubscriptionPercentage,stats.statsHeading,stats)}
                          // minValue={30,384}
                          // maxValue={60.384}
                          // text={`${totalSubscriptionPercentage}%`}
                          className={stats.ProgressBarClassName}
                          styles={buildStyles({
                            // rotation:0.25,
                            pathTransitionDuration: 1,
                          })}
                        />
                      </div>
                      <div className="flex-grow-1 ms-3">
                        <p className="mb-1 ft-11 subLabel">{stats.statsHeading}</p>
                        <p className="mb-0 b">{stats.value}</p>
                      </div>
                    </div>
                  </div>
                </div>
              
            )
          })}
        </div>

        <div className="showMobile">

          <p className="transumm">TRANSACTION SUMMARY</p>
          <div className="mobTransactionSummar">

            {DashboardHeaderSchema.map((stats,index) => {
              return (
               
                  <div className="indetailsmobvaluecolored" key={index}>
                    <p className="transactinDashLable">{stats.statsHeading}</p>
                    <p className="transactinDashValue">{stats.value}</p>
                  </div>
               
              );
            })
            }
          </div>
        </div> */}


      </div>


    </div>
    // </div>
  );
};

export default DashboardHeader;